import { Component, OnInit, OnDestroy } from '@angular/core';
import { TicketService } from 'src/app/services/ticket.service';
import { TicketFilterStatus, TicketStatus } from 'src/app/models/enums';
import { IPlayedTicket } from 'src/app/models/ticket/playedTicket';
import { Observable, Subscription, timer } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { DeployParams } from 'src/app/deployParams';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { CashOutService } from 'src/app/services/cash-out.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { StorageService } from 'src/app/services/util/storage.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';

@Component({
  selector: 'app-my-ticket',
  templateUrl: './my-ticket.component.html',
  styleUrls: ['./my-ticket.component.less']
})
export class MyTicketComponent implements OnInit, OnDestroy {
  tickets: IPlayedTicket[];
  protected subscription: Subscription = new Subscription();
  public loading = false;
  public isUsserLogged = true;
  // language: string;
  protected isMobileView = false;
  public ticketsFilterStatus = TicketFilterStatus.All;
  public ticketFilterStatusEnum = TicketFilterStatus;

  public loggedAffiliate: IAffiliate;

  public ticketStatusEnum = TicketStatus;

  protected cashOutTimer: Observable<any> = null;
  protected cashOutTimerSub: Subscription = null;

  protected lastFiveTimer: Observable<any> = null;
  protected lastFiveTimerSub: Subscription = null;

  currency: string = ConstantValues.CURRENCY;

  viewConfigurations = ViewConfigurations;

  public dateTo: Date;
  public dateFrom: Date;

  constructor(
    protected userService: UserService,
    protected ticketService: TicketService,
    protected cashOutService: CashOutService,
    protected utilityService: UtilityService,
    protected storageService: StorageService,
    protected authentificationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.isMobileView = this.utilityService.mobileView;
    this.isUsserLogged = (this.userService.user.userSBToken != null && this.userService.user.userSBToken && this.userService.user.userSBToken !== '');
    if (this.userService.user.userSBToken) {
      this.isUsserLogged = true;
    }

    if (this.authentificationService.loggedAffiliate && this.storageService.affiliateJwtToken) {
      this.isUsserLogged = true;
    }

    this.subscription.add(this.userService.userLoggedInOut$.subscribe((x) => {
      this.isUsserLogged = x;
    }));

    this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => {
      this.loggedAffiliate = this.authentificationService.loggedAffiliate;
      if (this.authentificationService.loggedAffiliate && this.storageService.affiliateJwtToken) {
        this.isUsserLogged = true;
      } else {
        this.isUsserLogged = false;
      }
    }));
    this.loggedAffiliate = this.authentificationService.loggedAffiliate;
    if (!this.isMobileView) {
      this.ticketsFilterStatusChange(this.ticketsFilterStatus);
      this.subscription.add(this.ticketService.reloadLastFiveTicketsOrUpdateTicket$.subscribe(x => this.reloadDesktopTickets()));
      // setup last five timer
      if (this.isUsserLogged) {
        this.lastFiveTimer = timer(300000, 300000);
        this.lastFiveTimerSub = this.lastFiveTimer.subscribe(t => this.reloadDesktopTickets());
      }
    } else {
      this.subscription.add(this.ticketService.reloadLastFiveTicketsOrUpdateTicket$.subscribe(x => this.updateCashedOutTicket(x)));

      this.subscription.add(this.userService.userLoggedInOut$.subscribe(isUsserLogged => {
        this.resetFilters();
        this.isUsserLogged = isUsserLogged;
        if (isUsserLogged) {
          this.getMyTicketsMobile();
        } else {
          this.tickets = [];
        }
      }));

      if (this.isUsserLogged) {
        this.resetFilters();
        this.getMyTicketsMobile();
      }
    }
  }

  ticketsFilterStatusChange(status: number) {
    this.ticketsFilterStatus = status;
    this.cashOutTimer = null;
    if (this.cashOutTimerSub) {
      this.cashOutTimerSub.unsubscribe();
    }

    this.reloadDesktopTickets();
  }

  reloadDesktopTickets() {
    if (!this.isUsserLogged) {
      return;
    }
    this.dateTo = new Date();
    this.dateFrom = new Date();
    this.dateTo.setHours(23, 59, 59, 999);
    this.dateFrom.setFullYear(this.dateTo.getFullYear());
    this.dateFrom.setMonth(this.dateTo.getMonth());
    this.dateFrom.setDate(this.dateTo.getDate() - 29);
    this.dateFrom.setHours(0, 0, 0, 0);

    const token = this.storageService.affiliateJwtToken ? this.storageService.affiliateJwtToken : this.userService.user.userSBToken;
    this.ticketService.getTicketsForDesktop(
      token,
      this.dateFrom,
      this.dateTo,
      this.utilityService.getTicketFilterString(this.ticketsFilterStatus)).subscribe(playedTickets => {
        // playedTickets.forEach(ticket => {
        //   if (ticket.status.code === TicketStatus.Pending) {
        //     if (this.cashOutTimer == null) {
        //       this.cashOutTimer = timer(0, 10000);
        //       this.cashOutTimerSub = this.cashOutTimer.subscribe(t => this.updateCashOutValue(t));
        //     }
        //   }
        // });
        this.tickets = playedTickets;
      });
  }

  updateCashOutValue(timerTick: any): void {
    this.tickets.forEach(playedTicket => {
      if (playedTicket.status.code === TicketStatus.Pending) {
        this.cashOutService.updateCashOutValue(playedTicket);
      }
    });
  }

  getMyTicketsMobile(resetList: boolean = true) { }

  updateCashedOutTicket(cashedOutTicketId: number) {
  }

  resetFilters() { }

  openTicketDetails(ticket: IPlayedTicket) {
    this.ticketService.openTicketDetails(ticket);
  }

  sellBet(ticket: IPlayedTicket): void {
    this.cashOutService.sellBet(ticket, !!this.authentificationService.loggedAffiliate);
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
    // not implemented
    // this.oddsUpdaterService.unsubscribeFromCasheBack();
    this.cashOutTimer = null;
    if (this.cashOutTimerSub) {
      this.cashOutTimerSub.unsubscribe();
    }
    if (this.lastFiveTimer) {
      this.lastFiveTimer = null;
    }
    if (this.lastFiveTimerSub) {
      this.lastFiveTimerSub.unsubscribe();
    }
  }
}


